import React, { useMemo } from "react";
import Chart from "react-apexcharts";

const ProjectCount = ({ data, isMobileView }) => {
  const chartData = useMemo(() => {
    return {
      series: [data.published || 0, data.active || 0],
      options: {
        chart: {
          type: "pie",
        },
        colors: ["#2F3A79", "#1A1A1A"],
        labels: ["Published", "Ongoing"],
        dataLabels: {
          enabled: true,
          formatter: (val) => `${Math.round(val)}%`,
          style: {
            fontSize: isMobileView ? "12px" : "15px",
            fontWeight: "bold",
            colors: ["#fff"],
          },
        },

        legend: {
          position: "right",
          verticalAlign: "center",
          offsetY: 70,
          offsetX: 15,
          fontSize: isMobileView ? "10px" : "15px",
          markers: {
            radius: 4,
          },
          labels: {
            useSeriesColors: false,
          },
        },
        responsive: [
          {
            breakpoint: 1500,
            options: {
              legend: {
                position: "bottom",
                offsetY: 0,
                offsetX: 0,
              },
            },
          },
        ],
      },
    };
  }, [data]);

  return <Chart options={chartData?.options} series={chartData?.series} type="pie" width="100%" height="100%" />;
};

export default ProjectCount;
